<template>
  <div class="column is-4-desktop is-6-touch" v-if="cta.link">
    <a :href="cta.link" :target="linkTarget">
      <div class="card-image" v-if="cta.image">
        <figure class="image is-3by1">
          <img :src="cta.image">
        </figure>
      </div>
      <span class="title is-size-4" v-html="cta.title" />
    </a>
    <div class="card-content" v-html="cta.blurb" />
  </div>
</template>

<script>
export default {
  props: {
    cta: {
      type: Object,
      required: true,
    },
  },
  computed: {
    linkTarget() {
      if (this.cta.link.startsWith('/')) {
        return '';
      }
      return '_blank';
    },
  },
}
</script>
